import React from 'react';
import { useNavigate } from "react-router-dom";

// ===== DATOS DE CALCULADORAS =====
const calculadoras = [
  {
    id: "conocer-mundo",
    title: "Conocer el mundo",
    description: "Crea tu plan para dar la vuelta al mundo",
    route: "/CalculadoraConocerMundo",
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=300&h=200&fit=crop"
  },
  {
    id: "educacion",
    title: "Educación",
    description: "Planea los costos educativos",
    route: "/CalculadoraEducacion",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=300&h=200&fit=crop"
  },
  {
    id: "evento-especial",
    title: "Evento especial",
    description: "Ahorra para ese día especial",
    route: "/CalculadoraEventoEspecial",
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=300&h=200&fit=crop"
  },
  {
    id: "fondo-salud",
    title: "Fondo de salud",
    description: "Evita complicaciones cuando las cosas sean complicadas",
    route: "/CalculadoraFondoSalud",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=300&h=200&fit=crop"
  },
  {
    id: "legado-financiero",
    title: "Fondo de legado",
    description: "Deja tu huella en la vida de tus hijos",
    route: "/CalculadoraLegadoFinanciero",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=300&h=200&fit=crop"
  },
  {
    id: "negocio",
    title: "Negocio",
    description: "Haz posible tu idea",
    route: "/CalculadoraNegocio",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop"
  },
  {
    id: "renovacion",
    title: "Renovación",
    description: "Haz esos cambios que siempre quisiste",
    route: "/CalculadoraRenovacion",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=300&h=200&fit=crop"
  },
  {
    id: "retiro",
    title: "Retiro",
    description: "Planifica tu futuro financiero",
    route: "/CalculadoraRetiro",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=300&h=200&fit=crop"
  },
  {
    id: "sabatico",
    title: "Año sabático",
    description: "Planea el descanso que necesitas",
    route: "/CalculadoraSabatico",
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=300&h=200&fit=crop"
  },
  {
    id: "solo-ahorrar",
    title: "Solo Ahorrar",
    description: "Nunca es tarde para ahorrar",
    route: "/CalculadoraSoloAhorrar",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=300&h=200&fit=crop"
  },
  {
    id: "vivienda",
    title: "Vivienda",
    description: "Haz posible la compra de la casa de tus sueños",
    route: "/CalculadoraVivienda",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=300&h=200&fit=crop"
  }
];

// ===== ESTILOS =====
const containerStyle = {
  display: "flex",
  justifyContent: "center",
  marginTop: "2%",
  flexWrap: "wrap",
  gap: "1.4%",
  rowGap: "10px"
};

const cardStyle = {
  width: "16%",
  padding: "1%",
  borderRadius: "3%",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  textAlign: "center",
  backgroundColor: "#fff",
  cursor: "pointer",
  transition: "transform 0.3s ease, box-shadow 0.3s ease"
};

const imageStyle = {
  width: "100%",
  borderRadius: "5px",
  height: "120px",
  objectFit: "cover"
};

const titleStyle = {
  fontSize: "1.1rem",
  fontWeight: "600",
  color: "#0c1f4d",
  margin: "10px 0 5px 0"
};

const descriptionStyle = {
  fontSize: "0.9rem",
  color: "#666",
  lineHeight: "1.4"
};

// ===== COMPONENTE PRINCIPAL =====
export default function CalculadorasHub() {
  const navigate = useNavigate();

  const handleCardClick = (route) => {
    navigate(route);
  };

  const handleCardHover = (e, isEntering) => {
    if (isEntering) {
      e.currentTarget.style.transform = 'translateY(-5px)';
      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.3)';
    } else {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
    }
  };

  return (
    <div style={containerStyle}>
      {calculadoras.map((calculadora) => (
        <div
          key={calculadora.id}
          style={cardStyle}
          onClick={() => handleCardClick(calculadora.route)}
          onMouseEnter={(e) => handleCardHover(e, true)}
          onMouseLeave={(e) => handleCardHover(e, false)}
          title={`Ir a ${calculadora.title}`}
        >
          <img 
            src={calculadora.image} 
            alt={calculadora.title} 
            style={imageStyle}
            loading="lazy"
          />
          <h3 style={titleStyle}>
            {calculadora.title}
          </h3>
          <p style={descriptionStyle}>
            {calculadora.description}
          </p>
        </div>
      ))}
    </div>
  );
}